import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import {
  fetchTemplateDetails,
  TemplateDetailsResponse,
} from "../api/endpoints/fetchTemplates";

export interface UseXFAFormTemplateDetailsParams {
  fileId: string;
  userEmail: string;
}

export function useXFAFormTemplateDetails(
  { fileId, userEmail }: UseXFAFormTemplateDetailsParams,
  options?: Omit<
    UseQueryOptions<TemplateDetailsResponse, Error, TemplateDetailsResponse, readonly unknown[]>,
    "queryKey" | "queryFn" | "enabled"
  >
): UseQueryResult<TemplateDetailsResponse, Error> {
  return useQuery<TemplateDetailsResponse, Error, TemplateDetailsResponse, readonly unknown[]>({
    queryKey: ["templateDetails", fileId] as const,
    queryFn: () => fetchTemplateDetails(String(fileId), String(userEmail)),
    enabled: Boolean(fileId),
    // Configure React Query to always call queryFn even when offline
    networkMode: 'always', // This ensures queryFn is called regardless of network status
    retry: false, // Disable automatic retries to let our custom offline logic handle it
    staleTime: 0, // Don't use stale data, always fetch fresh or from our IndexedDB
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes (formerly cacheTime)
    ...options,
  });
}


